import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import PageHeader from "../../../Routes/PageHeader";
import BoxCollectionPending from "./BoxCollectionPending";
import SalePending from "./SalePending";

const { TabPane } = Tabs;

function OutstandingPaymentsReport() {
  const history = useHistory();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("box-collection");

  // Parse URL parameters
  const getUrlParams = () => {
    const params = new URLSearchParams(location.search);
    return {
      page: parseInt(params.get("page")) || 1,
      take: parseInt(params.get("take")) || 10,
      dateFrom: params.get("dateFrom") || "",
      dateTo: params.get("dateTo") || "",
      user_id: params.get("user_id") || "",
      paid_status: params.get("paid_status") || "",
      search: params.get("search") || "",
      tab: params.get("tab") || "box-collection",
    };
  };

  const urlParams = getUrlParams();

  // Initialize activeTab from URL and sync with URL changes
  useEffect(() => {
    const currentTab = urlParams.tab || "box-collection";
    if (currentTab !== activeTab) {
      setActiveTab(currentTab);
    }
    // If tab is not in URL, add it
    if (!urlParams.tab) {
      const params = new URLSearchParams(location.search);
      params.set("tab", currentTab);
      if (!params.get("page")) {
        params.set("page", "1");
      }
      if (!params.get("take")) {
        params.set("take", "10");
      }
      history.replace({
        pathname: location.pathname,
        search: params.toString(),
      });
    }
  }, [location.search]);

  // Update URL with new parameters
  const updateUrlParams = (updates, tabOverride = null) => {
    const params = new URLSearchParams(location.search);
    
    // Update each parameter
    Object.keys(updates).forEach((key) => {
      if (updates[key] === "" || updates[key] === null || updates[key] === undefined) {
        params.delete(key);
      } else {
        params.set(key, updates[key]);
      }
    });

    // Always set the current tab (use override if provided, otherwise use state)
    params.set("tab", tabOverride || activeTab);

    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    });
  };

  const handleFilter = (filters) => {
    updateUrlParams({
      dateFrom: filters.dateFrom || "",
      dateTo: filters.dateTo || "",
      user_id: filters.user_id || "",
      paid_status: filters.paid_status || "",
      search: filters.search || "",
      page: 1, // Reset to page 1 when filters change
    }, activeTab);
  };

  const handlePageChange = (page, pageSize) => {
    updateUrlParams({
      page: page,
      take: pageSize,
    });
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    // Clear all filters and pagination when switching tabs
    const params = new URLSearchParams();
    params.set("tab", key);
    params.set("page", "1");
    params.set("take", "10");
    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    });
  };

  return (
    <div>
      <PageHeader
        PageName={"Outstanding Payments Report"}
        breadScrum={"Admin / Report / Outstanding Payments"}
      />
      <div style={{ padding: "20px", background: "#fff" }}>
        <Tabs activeKey={activeTab} onChange={handleTabChange} type="card">
          <TabPane tab="Box Collection Pending" key="box-collection">
            <BoxCollectionPending
              dateFrom={urlParams.dateFrom}
              dateTo={urlParams.dateTo}
              user_id={urlParams.user_id}
              paid_status={urlParams.paid_status}
              search={urlParams.search}
              onFilter={handleFilter}
              pageConfig={{ page: urlParams.page, take: urlParams.take }}
              onPageChange={handlePageChange}
            />
          </TabPane>
          <TabPane tab="Sale Pending" key="sale-pending">
            <SalePending
              dateFrom={urlParams.dateFrom}
              dateTo={urlParams.dateTo}
              user_id={urlParams.user_id}
              paid_status={urlParams.paid_status}
              search={urlParams.search}
              onFilter={handleFilter}
              pageConfig={{ page: urlParams.page, take: urlParams.take }}
              onPageChange={handlePageChange}
            />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
}

export default OutstandingPaymentsReport;

